module.exports = __webpack_public_path__ + "assets/dumptruck.svg?1e4f32caf6d8b33b978044dfd68d2c55";